import { ReactNode } from "react";
import styles from "./Badge.module.css";

type Variant =
  | "neutral"
  | "admin"
  | "user"
  | "accent"
  | "info"
  | "success"
  | "warn"
  | "warning"
  | "danger";

interface Props {
  variant?: Variant;
  /** When true, prepend a 6px currentColor dot inside the badge. */
  dot?: boolean;
  children: ReactNode;
}

// Map variant string → CSS-module class name. Some variants alias to each
// other (admin ↔ accent, warn ↔ warning, user ↔ neutral) for back-compat.
const VARIANT_CLASS: Record<Variant, string> = {
  neutral: "neutral",
  admin: "admin",
  user: "user",
  accent: "admin",
  info: "info",
  success: "success",
  warn: "warning",
  warning: "warning",
  danger: "danger",
};

export function Badge({ variant = "neutral", dot, children }: Props) {
  const cls = `${styles.badge} ${styles[VARIANT_CLASS[variant]]}`;
  return (
    <span className={cls}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
}
